export { default } from './Search';



// WEBPACK FOOTER //
// ./src/components/Header/components/Search/index.ts